var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnveloppe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.168 16.3333L35.898 20.3722C31.8448 22.624 29.8182 23.7499 27.672 24.1913C25.7725 24.5819 23.8134 24.5819 21.9139 24.1913C19.7677 23.7499 17.7411 22.624 13.6879 20.3722L6.41797 16.3333M12.9513 38.7917H36.6346C38.9215 38.7917 40.065 38.7917 40.9384 38.3466C41.7068 37.9551 42.3314 37.3305 42.7229 36.5621C43.168 35.6887 43.168 34.5452 43.168 32.2583V16.7417C43.168 14.4548 43.168 13.3114 42.7229 12.4379C42.3314 11.6696 41.7068 11.0449 40.9384 10.6534C40.065 10.2083 38.9215 10.2083 36.6346 10.2083H12.9513C10.6644 10.2083 9.52098 10.2083 8.64751 10.6534C7.87918 11.0449 7.25451 11.6696 6.86303 12.4379C6.41797 13.3114 6.41797 14.4548 6.41797 16.7417V32.2583C6.41797 34.5452 6.41797 35.6887 6.86303 36.5621C7.25451 37.3305 7.87918 37.9551 8.64751 38.3466C9.52098 38.7917 10.6644 38.7917 12.9513 38.7917Z",
    stroke: "url(#paint0_linear_1127_28187)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1127_28187",
    x1: 6.41797,
    y1: 38.7917,
    x2: 43.168,
    y2: 38.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnveloppe);
export default __webpack_public_path__ + "static/media/enveloppe.fa66f97be2e05aff9a8772a8625b4256.svg";
export { ForwardRef as ReactComponent };